import { render, staticRenderFns } from "./Organizer.vue?vue&type=template&id=56a1f7e5&scoped=true&"
import script from "./Organizer.vue?vue&type=script&lang=js&"
export * from "./Organizer.vue?vue&type=script&lang=js&"
import style0 from "./Organizer.vue?vue&type=style&index=0&id=56a1f7e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a1f7e5",
  null
  
)

export default component.exports